import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { getServiceRequestByCustomer, allocateItems, sendCustomerAccept } from '../../Api/serviceApiMaster';
import Sample14 from "../../Components/Logo";
import { Table } from "react-bootstrap";
import { useAuth } from '../../Context/AuthContext';
import { FaCheck } from "react-icons/fa";

const CustomerRequestList = () => {
    const { user } = useAuth();
    const location = useLocation();
    const [serviceData, setServiceData] = useState({});
    const [loading, setLoading] = useState(false);


    console.log(user, 'user')

    const confirmationRequest = async (sendId) => {
        setLoading()
        const res = await sendCustomerAccept(sendId, user?.userId);
        console.log(res, 'res from email')
        if (res.status === 200) {
            toast.success("Service Accepted");
            fetchRequestByCustomer()
        }
        setLoading()
    }

    const fetchRequestByCustomer = async () => {
        setLoading(true);
        try {
            const response = await getServiceRequestByCustomer(user?.userId);
            setServiceData(response);
        } catch (error) {
            // toast.error(`Error loading service data: ${error.message}`);
            console.log(error, 'error')
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {

        fetchRequestByCustomer();
    }, []);


    return (
        <>
            <div className="main-content expand">
                <Container fluid className="fields-container">
                    {loading && (
                        <div className="loading-overlay">
                            <Sample14 />
                        </div>
                    )}

                    <div className="page-headings">
                        <div className="heading-name">
                            <h2 className="list-title">Service Done</h2>
                        </div>
                        {/* <div className="heading-options">
                            <button className="file-btn download-btn"
                                onClick={sendMailforRequest}
                            >
                                <MdEmail className='file-icon' />
                            </button>
                        </div> */}

                    </div>

                    {serviceData?.length > 0 ? (
                        <Table bordered hover responsive className="data-table">
                            <thead>
                                <tr>
                                    {/* <th>Ser.</th> */}
                                    <th>Request Item Id</th>
                                    <th>Request Id</th>
                                    <th>Service Data</th>
                                    <th>Type</th>
                                    <th>quantity</th>
                                    <th>serviceHours</th>
                                    <th>Preferred Date</th>
                                    <th>Proposed Date</th>
                                    <th>Allocated Qty</th>
                                    <th> price</th>
                                    <th>amount</th>
                                    <th>cgst</th>
                                    <th>sgst</th>
                                    <th>igst</th>
                                    <th> grandTotal</th>
                                     <th> Before Image</th>
                                    <th> After Image</th>
                                    {/* <th>taxType</th> */}
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {serviceData?.map((budget, index) => (
                                    <tr key={index}>
                                        <td>{budget.requestItemId}</td>
                                        <td>{budget.requestId}</td>
                                        <td>{budget.serviceData}</td>
                                        <td>{budget.serviceType}</td>
                                        <td>{budget.quantity
                                        }</td>
                                        <td>{budget.serviceHours}</td>
                                        <td>{budget.preferredDate} at {budget?.preferredTime}</td>
                                        <td>{budget?.proposedDate} at {budget?.proposedTime}</td>

                                        <td>{budget.allocatedQuantity}</td>
                                        <td>{budget.price}</td>
                                        <td>{budget.amount}</td>
                                        <td>{budget.cgst}</td>
                                        <td>{budget.sgst
                                        }</td>
                                        <td>{budget.igst}</td>
                                        <td>{budget.grandTotal
                                        }</td>
                                        
                                        <td>{budget.beforeImage ? (
                                            <a href={budget.beforeImage} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "underline", color: "#007BFF" }}>
                                                Click Here
                                            </a>
                                        ) : " "}</td>
                                        <td>{budget.afterImage ? (
                                            <a href={budget.afterImage} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "underline", color: "#007BFF" }}>
                                                Click Here
                                            </a>
                                        ) : " "}</td>
                                        {/* <td>{budget.taxType}</td> */}
                                        <td>{budget?.serviceStatusName}</td>
                                        <td>
                                            <Button className="edit-link" onClick={() => {
                                                confirmationRequest(budget?.requestItemId);
                                            }}>
                                                <FaCheck className="edit-icon" />
                                            </Button>
                                             <p className='btn-title'>Accept It.</p>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    ) : (
                        <p className="no-data">No Data found.</p>
                    )}
                </Container>
            </div>
        </>
    )
}

export default CustomerRequestList